<head>
    <!-- Google Tag Manager -->

    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

    <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->
<div *ngIf="mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <!-- <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">

                <tr>
                    <td>
                        <audio controls>
                            <source
                                src="https://drive.google.com/uc?id=1PyS3KEfApUNrsewzAI1zdhK65WyQ-qiV&export=download"
                                type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio><br /><br />
                    </td>
                </tr>
                <tr>
                    <td style="text-align:center;">
                        <i class="fa-solid fa-arrow-left fa-lg"></i>
                    </td>
                </tr>
        </div>

        </td> -->
                    <td style="padding-left:4%;
                    padding-right:4%;
                    padding-top: 5%;
                    padding-bottom: 3%">
                        <h1 style="color: #5ECE42">To risk or not to risk?</h1><br />
                        We have all seen it. It’s everywhere, and there’s no way of escaping it. Yes, I’m talking about
                        the
                        “trading may be risky” warning that you see pretty much all over the place.<br /><br />

                        As an active investor, you should be aware of just how much risk you are taking on with every
                        decision
                        you make. That can be hard enough to figure out when you’re trading in the traditional
                        investment
                        markets, but with Copy Trading thrown into the mix, assessing your risk with any kind of
                        accuracy
                        becomes almost impossible. So, what’s a social investor to do?
                        <br /><br />
                        <h2>Introducing: The Risk Score </h2><br />
                        So right off the bat, let me make it clear that this is a feature we are currently working on
                        and plan to
                        release to our community within the next few months.<br /><br />

                        The principle behind the Risk Score is very simple: we want you to be able to assess the exact
                        risk you’re
                        taking on with every trading decision, including Copy Trading. Not just get a feel of the risk,
                        but actually
                        be able to measure it with cold hard numbers.<br /><br />

                        The risk score will provide you with an overall portfolio risk score, as well as a breakdown of
                        what this
                        risk is made up of. This will be available for view on all our members’ profiles, which means
                        it’s not only
                        your own portfolio you’ll be able to better analyze, but also everyone else’s!
                        <br /><br />
                        When it comes to Copy Trading, any new trader that you copy will impact your Risk score based on
                        the
                        way the trader you copy behaves: their choice of instruments, their choice of leverage, the
                        percentage
                        of their equity that is invested on a single instrument – all these and more are taken into
                        account in the
                        algorithm we have employed. When combining all the data together, we are able to calculate with
                        a
                        great degree of accuracy the risk a specific trader brings to your portfolio. So basically,
                        you’ll be better
                        able to asses any trader you want to copy, since you will be able to not only see his/her gain
                        and
                        performance, but also understand the risk he/she is taking.<br /><br />

                        <h2>How does it work? </h2><br />
                        Before we start, it’s important to emphasize that the risk score is based solely on a trader’s
                        past
                        performance, and as such it cannot and does not indicate future results.<br /><br />

                        Without going into hardcore math algorithms, the basic idea is that every instrument has an
                        average
                        daily movement, which indicates how volatile it is. Let’s say instrument X shifts on average
                        around 2% a
                        day (during a given day it will usually go up or down by around 2% from its price at the
                        beginning of the
                        day). Statistically, if we multiply this average change by 3, we create a range that will be
                        correct 99% of
                        the time. So, in our example, 99% of the time, instrument X will move up or down by a maximum of
                        6%
                        within a single day.<br /><br />

                        This basic understanding is combined with the fact that different leverage settings change the
                        risk
                        percentage, and of course the fact that most of the traders in our community invest in more than
                        one
                        instrument. Some positions combine to reduce risk (if you buy EUR/USD and USD/JPY
                        simultaneously,
                        then together the two positions cover the possibility of the USD going down on the one hand, and
                        up on
                        the other, which means that your risk here is lower since they complement – hedge – each other).
                        However, if your open trading positions don’t hedge each other, this means that the risk for
                        these trades
                        might be higher, as each trade can go the opposite way from what you were hoping.<br /><br />

                        Moreover, if you’re copying multiple traders, it’s important to take into account how their
                        positions
                        correlate – if they all invest the same way, your risk is higher, if on the other hand they
                        hedge each
                        other’s positions, your risk is lower.<br /><br />

                        As a first step, the risk score will not be updated in real time, and we will inform you in
                        advance in
                        regards to the frequency of the updates for this tool. Of course, our aim is to get it to a
                        point where you
                        will be able to see the changes to your risk score in real time, and that will happen as a part
                        of an update
                        we will introduce in the future.<br /><br />

                        <h2>How will I see it?</h2><br />
                        The algorithm takes all the parameters into consideration, and gives your portfolio a “risk
                        score” that
                        ranges from 1-10. Each score represents a percentage range, and is meant to help you better
                        understand the risk that your investments may pose to your equity.<br /><br />
                        <div style="    display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;">
                            <table class="riskTable" style="width:60%">
                                <tr class="riskTableHeader">
                                    <th class="riskTable" style="width: 50%">Risk Score</th>
                                    <th class="riskTable" style="width: 50%">Max portfolio volatility</th>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">1</td>
                                    <td class="riskTable">0.5%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">2</td>
                                    <td class="riskTable">1.2%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">3</td>
                                    <td class="riskTable">2.0%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">4</td>
                                    <td class="riskTable">2.7%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">5</td>
                                    <td class="riskTable">3.9%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">6</td>
                                    <td class="riskTable">5.4%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">7</td>
                                    <td class="riskTable">7.7%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">8</td>
                                    <td class="riskTable">15.5%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">9</td>
                                    <td class="riskTable">23.3%</td>
                                </tr>
                                <tr class="riskTableRow">
                                    <td class="riskTable">10</td>
                                    <td class="riskTable">>23.3%</td>
                                </tr>
                            </table>
                        </div>
                        <br /><br />
                        Whenever you add a new investment to your portfolio (be it an instrument or a copied trader),
                        your risk
                        will be recalculated and you will see your decision’s impact on your risk score. In the future,
                        we will work
                        to elaborate this feature so you can see the projected risk impact that a trader can potentially
                        have on
                        your portfolio. However, in the first version of this tool, you will only see the risk impact
                        after you’ve
                        copied the trader.
                        <br /><br />

                        In addition, you will have a deep analysis of your own portfolio, enabling you to get a better
                        understanding regarding your own investment strategy in real time. That kind of analysis will be
                        available to all, meaning you’ll be able to see the deep analysis of all the traders in the
                        community- but
                        again, the ability to calculate the correlation between them in advance is still in early
                        development
                        stages, and will become available in later versions.<br /><br />

                        It’s important to note: this feature is meant to help you make wiser decisions, but it will not
                        tell you
                        what to do. We firmly believe that the responsibility for one’s actions lies in one’s choices,
                        and we are
                        by no means trying to tell you how you should invest. <br /><br />

                        <h2>So, what's next?</h2><br />
                        Over the next few months, until we launch this new feature, we will publish several risk
                        analysis posts
                        and review of some of our most copied traders. This way, you’ll have a better understanding as
                        to how
                        the Risk Score works and what it means for you.<br /><br />

                        We trust that this important tool will help you optimize your portfolio to get the best possible
                        results,
                        
                        according to your investment needs and expectations.<br /><span scrolledTo #scrolledToElement="scrolledTo"></span><br />
                        
                        Of course, you are more than welcome to ask any question you might have regarding this on our
                        Customer Service wall, or here in the comments. This feature is still under development, so
                        final details
                        (including launch date) are subject to change.<br /><br />
                        
                        It’s really important for us to hear your comments on this one – this is a tool meant to help
                        you become
                        a better trader, and we want you to be a part of the process of creating it!
                    </td>
                </tr>
            </table>
        </div>
        <br />
        <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

        <section class="linkedIn">
            <div class="shell">
                <div class="section__content">
                    <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
                        rel="noopener noreferrer"><img class="linkedImg"
                            src="../../assets/img/Follow Us on LinkedIn.png" alt="Follow us on LinkedIn" /></a>
                </div>
            </div>
        </section>
    </div>
    <div [class.sticky2-mob-stop]="scrolledToElement.reached" [class.sticky2-mob]="scrolledToElement.notreached">
        <div class="row">
            <div class="col-auto" style="align-items: center;
                    display: grid;margin-left:2%">

                <i [routerLink]="['/']" fragment="about" class="fa-solid fa-arrow-left fa-3x"></i>
            </div>
            <div class="col" style="width: 70%;">
                <audio controls>
                    <source src="https://theapi.backseat-trader.com/Risk as reported by eToro.mp3"
                        type="audio/mpeg">
                    Your browser does not support the audio element.
                </audio>
            </div>
            <div class="col-auto" style="align-items: center;
            display: grid;margin-right:2%">

                <i [routerLink]="['/']" class="fa-solid fa-house fa-3x" (click)="removePos()"></i>
            </div>
        </div>

    </div>
</div>
<div *ngIf="!mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">

                <tr>
                    <td>
                        <audio controls>
                            <source
                                src="https://theapi.backseat-trader.com/Risk as reported by eToro.mp3"
                                type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio><br /><br />
                    </td>
                </tr>
                <tr>
                    <td style="text-align:center;">
                        <i [routerLink]="['/']" fragment="about" class="fa-solid fa-arrow-left fa-lg"></i>
                    </td>
                </tr>
                <br />
                <tr>
                    <td style="text-align: center;">
                        <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">Risk</span><br />
                    </td>
                </tr>
        </div>

        </td>
        <td style="width: 79%;
                        padding-right: 19%;
                        padding-top: 3%;
                        padding-bottom: 3%;">
            <!-- <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">Smart Stock Curation</span><br/> -->
            <h1 style="color: #5ECE42">To risk or not to risk?</h1><br />
            We have all seen it. It’s everywhere, and there’s no way of escaping it. Yes, I’m talking about the
            “trading may be risky” warning that you see pretty much all over the place.<br /><br />

            As an active investor, you should be aware of just how much risk you are taking on with every decision
            you make. That can be hard enough to figure out when you’re trading in the traditional investment
            markets, but with Copy Trading thrown into the mix, assessing your risk with any kind of accuracy
            becomes almost impossible. So, what’s a social investor to do?
            <br /><br />
            <h2>Introducing: The Risk Score </h2><br />
            So right off the bat, let me make it clear that this is a feature we are currently working on and plan to
            release to our community within the next few months.<br /><br />

            The principle behind the Risk Score is very simple: we want you to be able to assess the exact risk you’re
            taking on with every trading decision, including Copy Trading. Not just get a feel of the risk, but actually
            be able to measure it with cold hard numbers.<br /><br />

            The risk score will provide you with an overall portfolio risk score, as well as a breakdown of what this
            risk is made up of. This will be available for view on all our members’ profiles, which means it’s not only
            your own portfolio you’ll be able to better analyze, but also everyone else’s!
            <br /><br />
            When it comes to Copy Trading, any new trader that you copy will impact your Risk score based on the
            way the trader you copy behaves: their choice of instruments, their choice of leverage, the percentage
            of their equity that is invested on a single instrument – all these and more are taken into account in the
            algorithm we have employed. When combining all the data together, we are able to calculate with a
            great degree of accuracy the risk a specific trader brings to your portfolio. So basically, you’ll be better
            able to asses any trader you want to copy, since you will be able to not only see his/her gain and
            performance, but also understand the risk he/she is taking.<br /><br />

            <h2>How does it work? </h2><br />
            Before we start, it’s important to emphasize that the risk score is based solely on a trader’s past
            performance, and as such it cannot and does not indicate future results.<br /><br />

            Without going into hardcore math algorithms, the basic idea is that every instrument has an average
            daily movement, which indicates how volatile it is. Let’s say instrument X shifts on average around 2% a
            day (during a given day it will usually go up or down by around 2% from its price at the beginning of the
            day). Statistically, if we multiply this average change by 3, we create a range that will be correct 99% of
            the time. So, in our example, 99% of the time, instrument X will move up or down by a maximum of 6%
            within a single day.<br /><br />

            This basic understanding is combined with the fact that different leverage settings change the risk
            percentage, and of course the fact that most of the traders in our community invest in more than one
            instrument. Some positions combine to reduce risk (if you buy EUR/USD and USD/JPY simultaneously,
            then together the two positions cover the possibility of the USD going down on the one hand, and up on
            the other, which means that your risk here is lower since they complement – hedge – each other).
            However, if your open trading positions don’t hedge each other, this means that the risk for these trades
            might be higher, as each trade can go the opposite way from what you were hoping.<br /><br />

            Moreover, if you’re copying multiple traders, it’s important to take into account how their positions
            correlate – if they all invest the same way, your risk is higher, if on the other hand they hedge each
            other’s positions, your risk is lower.<br /><br />

            As a first step, the risk score will not be updated in real time, and we will inform you in advance in
            regards to the frequency of the updates for this tool. Of course, our aim is to get it to a point where you
            will be able to see the changes to your risk score in real time, and that will happen as a part of an update
            we will introduce in the future.<br /><br />

            <h2>How will I see it?</h2><br />
            The algorithm takes all the parameters into consideration, and gives your portfolio a “risk score” that
            ranges from 1-10. Each score represents a percentage range, and is meant to help you better
            understand the risk that your investments may pose to your equity.<br /><br />
            <div style="    display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;">
                <table class="riskTable" style="width:60%">
                    <tr class="riskTableHeader">
                        <th class="riskTable" style="width: 50%">Risk Score</th>
                        <th class="riskTable" style="width: 50%">Max portfolio volatility</th>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">1</td>
                        <td class="riskTable">0.5%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">2</td>
                        <td class="riskTable">1.2%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">3</td>
                        <td class="riskTable">2.0%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">4</td>
                        <td class="riskTable">2.7%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">5</td>
                        <td class="riskTable">3.9%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">6</td>
                        <td class="riskTable">5.4%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">7</td>
                        <td class="riskTable">7.7%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">8</td>
                        <td class="riskTable">15.5%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">9</td>
                        <td class="riskTable">23.3%</td>
                    </tr>
                    <tr class="riskTableRow">
                        <td class="riskTable">10</td>
                        <td class="riskTable">>23.3%</td>
                    </tr>
                </table>
            </div>
            <br /><br />
            Whenever you add a new investment to your portfolio (be it an instrument or a copied trader), your risk
            will be recalculated and you will see your decision’s impact on your risk score. In the future, we will work
            to elaborate this feature so you can see the projected risk impact that a trader can potentially have on
            your portfolio. However, in the first version of this tool, you will only see the risk impact after you’ve
            copied the trader.
            <br /><br />

            In addition, you will have a deep analysis of your own portfolio, enabling you to get a better
            understanding regarding your own investment strategy in real time. That kind of analysis will be
            available to all, meaning you’ll be able to see the deep analysis of all the traders in the community- but
            again, the ability to calculate the correlation between them in advance is still in early development
            stages, and will become available in later versions.<br /><br />

            It’s important to note: this feature is meant to help you make wiser decisions, but it will not tell you
            what to do. We firmly believe that the responsibility for one’s actions lies in one’s choices, and we are
            by no means trying to tell you how you should invest. <br /><br />

            <h2>So, what's next?</h2><br />
            Over the next few months, until we launch this new feature, we will publish several risk analysis posts
            and review of some of our most copied traders. This way, you’ll have a better understanding as to how
            the Risk Score works and what it means for you.<br /><br />

            We trust that this important tool will help you optimize your portfolio to get the best possible results,
            according to your investment needs and expectations.<br /><br />

            Of course, you are more than welcome to ask any question you might have regarding this on our
            Customer Service wall, or here in the comments. This feature is still under development, so final details
            (including launch date) are subject to change.<br /><br />

            It’s really important for us to hear your comments on this one – this is a tool meant to help you become
            a better trader, and we want you to be a part of the process of creating it!


        </td>
        </tr>
        </table>
    </div>
    <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

    <section class="linkedIn">
        <div class="shell">
            <div class="section__content">
                <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
                    rel="noopener noreferrer"><img class="linkedImg" src="../../assets/img/Follow Us on LinkedIn.png"
                        alt="Follow us on LinkedIn" /></a>
            </div>
        </div>
    </section>
</div>
</div>